<div class="doc-grid-container">
  <!-- Display message when no data is available -->
  @if (alldata.length <= 0) {
    <div class="no-data-found">No data found</div>
  }

  <!-- Table with dynamic columns and rows -->
  @if (alldata.length > 0) {
    <ng-container>
      <table class="table">
        <!-- Table Headers -->
        <thead>
          <tr>
            <th
              *ngFor="let column of columns"
              [ngStyle]="column.style"
              [class.action]="column.key === 'action'"
            >
              {{ column.header }}
              <ng-container *ngIf="column.key === 'created_at'">
                <button
                  (click)="sortBy('created_at')"
                  style="background: none; border: none; cursor: pointer"
                >
                  <span *ngIf="sortDirection === 'asc'">&#8593;</span>
                  <span *ngIf="sortDirection === 'desc'">&#8595;</span>
                </button>
              </ng-container>
            </th>
          </tr>
        </thead>

        <!-- Table Rows (Custom Logic for each data row) -->
        <tbody>
          <tr *ngFor="let row of currentPageData; let k = index">
            <td *ngFor="let column of columns" [ngStyle]="column.style">
              <!-- <ix-tooltip for=".{{ column.key + k }}">
              {{ formatValue(row[column.key], column?.path) }}
            </ix-tooltip> -->
              @if (column.key !== 'action') {
                <div
                  *ngIf="column.key === 'job_id'"
                  class="{{ column.key + k + ' truncate-3-lines' }}"
                >
                  {{ currentPageStartIndex + k + 1 }}
                </div>
                <div
                  *ngIf="column.key === 'created_at' || column.key === 'report_updated_at'"
                  class="{{ column.key + k + ' truncate-3-lines' }}"
                >
                  {{ row[column.key] | date: 'dd-MM-yyyy HH:mm:ss' }}
                </div>
                <div
                  *ngIf="
                    column.key !== 'job_id' &&
                    column.key !== 'created_at' &&
                    column.key !== 'report_updated_at'
                  "
                  class="{{ column.key + k + ' truncate-3-lines' }}"
                >
                  {{ formatValue(row[column.key], column?.path) }}
                </div>
              }
              @if (column.key === 'action') {
                <div class="action">
                  <ng-container *ngFor="let actionItem of column.type">
                    @if (actionItem !== 'like' && actionItem !== 'dislike') {
                      <ix-icon-button
                        [icon]="actionItem.includes('download') ? 'download' : actionItem"
                        class="action-item"
                        [variant]="actionItem === 'trashcan' ? 'danger' : 'primary'"
                        (click)="cardAction(row, actionItem)"
                        [ghost]="true"
                        [disabled]="
                          actionItem.includes('downloadReports') && row.status !== 'Completed'
                        "
                      ></ix-icon-button>
                    } @else {
                      <button
                        class="icon-btn"
                        aria-label="feedback"
                        (click)="cardAction(row, actionItem)"
                      >
                        @if (actionItem === 'like') {
                          <img
                            *ngIf="!row.feedback || row.feedback === -1"
                            src="assets/images/{{ actionItem }}.svg"
                            alt=""
                          />
                          <img
                            *ngIf="row.feedback && row.feedback === 1"
                            src="assets/images/fill-like.svg"
                            alt=""
                          />
                        } @else {
                          <img
                            *ngIf="!row.feedback || row.feedback === 1"
                            src="assets/images/{{ actionItem }}.svg"
                            alt=""
                          />
                          <img
                            *ngIf="row.feedback === -1"
                            src="assets/images/fill-dislike.svg"
                            alt=""
                          />
                        }
                      </button>
                    }
                  </ng-container>
                </div>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  }

  <div class="feedback-text">
    Note: Was something helpful or irrelevant? Share your thoughts on its accuracy and clarity —
    <a href="mailto:kumar.rk.rajesh&#64;siemens.com"> kumar.rk.rajesh@siemens.com</a>
  </div>

  <!-- Pagination Controls -->
  @if (alldata.length > 0 && showPaginator) {
    <ix-pagination
      class="paginator"
      showItemCount
      [itemCount]="itemsPerPage"
      count="{{ totalPages }}"
      [selectedPage]="selectedPage"
      (pageSelected)="onPageChange($event)"
      (itemCountChanged)="onItemCountChanged($event)"
    ></ix-pagination>
  }
</div>
